/**
 * This cl-results-table renders the following configs on the City Life Calculator:
 * - client/config/city-life/col-results-table.js - 6 items
 * - client/config/city-life/demographics-results-table.js - 3 items
 * - client/config/city-life/qol-results-table.js - 2 items
 * - client/config/city-life/school-results-table.js - 1 item
 */

// Dependencies

import React, { useState } from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { map } from 'lodash';

import { Text, Box } from '@nerdwallet/currency';
import { ControlledAccordion } from '@nerdwallet/react-accordion';
import CityResultsTable from '../../shared/city-results-table/city-results-table';
import { ViewConfigProps } from '../../shared/types';

// CSS
import styles from './cl-results-table.module.less';

type ClResultsTableProps = {
  data: Record<string, any>;
  trackingFormName: string;
  viewConfig: ViewConfigProps[];
};

const ClResultsTable = ({
  data,
  trackingFormName = null,
  viewConfig,
}: ClResultsTableProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleItem = (index) => {
    if (activeIndex !== index) {
      setActiveIndex(index);
    } else {
      setActiveIndex(null);
    }
  };

  const accordionProps = {
    analytics: {
      enabled: true,
      payload: {
        entityName: trackingFormName,
      },
    },
    items: map(
      viewConfig,
      ({ header, trackingFieldName, className, contentConfig }, index) => {
        const keyVal = `col-results-table-row-${index}`;

        return {
          id: trackingFieldName,
          expanded: activeIndex === index,
          onSelect: () => toggleItem(index),
          key: keyVal,
          title: (
            <Box>
              <Box className={classnames(styles.toolTip, styles[className])} />
              <Box display="flex" justifyContent="space-between">
                <Text bold={false}>{header}</Text>
              </Box>
            </Box>
          ),
          children: (
            <CityResultsTable
              config={contentConfig}
              data={data}
              tableColumnSize={6}
            />
          ),
        };
      }
    ),
  };

  return (
    <Box paddingTop={2} paddingBottom={4} paddingX={2}>
      <ControlledAccordion {...accordionProps} />
    </Box>
  );
};

ClResultsTable.displayName = 'ClResultsTable';

export default ClResultsTable;
